import { render, staticRenderFns } from "./purchaseRecord.vue?vue&type=template&id=cbbf1df6&scoped=true"
import script from "./purchaseRecord.vue?vue&type=script&lang=js"
export * from "./purchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./purchaseRecord.vue?vue&type=style&index=0&id=cbbf1df6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf1df6",
  null
  
)

export default component.exports